/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/DefaultDownpaymentAmount/Type"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataDefaultDownpaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_downpayment.type',
})
let constantData = 'FIXED'
let aggregateData = fromAggregate.equals(settingsDataDefaultDownpaymentTypeValueData, constantData)
let onClick = fromHelpers.useOnClickFixed({
  children,
  viewPath
  
})
let settingsDataDefaultDownpaymentTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_downpayment.type',
})
let constantData1 = 'PERCENTAGE'
let aggregateData1 = fromAggregate.equals(settingsDataDefaultDownpaymentTypeValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickPercentage({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Type.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-bxIu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="settings.data.default_downpayment.type"
 data="'FIXED'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 text="Fixed"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="settings.data.default_downpayment.type"
 data="'PERCENTAGE'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData1}
 text="% of treatment fee"
/>
</div>
{children}
</React.Fragment>)
}